module.exports = __webpack_public_path__ + "static/img/咨询我们.e6c93400.png";